(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function(e) {
  var form = e.target;
  if (!form.classList || !form.classList.contains('card-product__qa-form')) return;
  e.preventDefault();
  var btn = form.querySelector('.card-product__quick-add-btn');
  if (!btn) return;
  var origLabel = btn.getAttribute('data-label') || btn.textContent.trim();
  var addingLabel = btn.getAttribute('data-adding') || 'Adding…';
  var addedLabel = btn.getAttribute('data-added') || 'Added';
  btn.textContent = addingLabel;
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    body: new FormData(form)
  })
  .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
  .then(function() {
    btn.textContent = addedLabel;
    setTimeout(function() {
      btn.textContent = origLabel;
      btn.disabled = false;
    }, 1800);
    if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
  })
  .catch(function() {
    btn.textContent = origLabel;
    btn.disabled = false;
  });
});
  } catch(e) { console.error(e); }
})();

})();
